module.exports = __webpack_public_path__ + "src/img/notice.d082635c.svg";